import React from "react";
import { Card, Stack, TextInput, Title, Divider, Group } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { setEksempelValue } from "./eksempelrapportThunks";

export const EksempelGenerelInfo: React.FC = () => {
  const dispatch = useAppDispatch();

  const edited = useAppSelector((s) => s.reportReducer.editedData[101]);
  if (!edited) return null;

  return (
    <Card withBorder radius="md" p="md">
      <Stack gap="md">
        <Title order={5}>Generell info</Title>
        <Divider />

        <TextInput
          label="Utarbetat av"
          value={edited.generellInfo.utarbeidetAv}
          onChange={(e) => dispatch(setEksempelValue("generellInfo.utarbeidetAv", e.currentTarget.value))}
        />

        <TextInput
          label="Kontrollerat av"
          value={edited.generellInfo.kontrollertAv}
          onChange={(e) => dispatch(setEksempelValue("generellInfo.kontrollertAv", e.currentTarget.value))}
        />

        <TextInput
          label="Godkänt av"
          value={edited.generellInfo.godkjentAv}
          onChange={(e) => dispatch(setEksempelValue("generellInfo.godkjentAv", e.currentTarget.value))}
        />

        <Group grow>
          <TextInput
            label="Dokumentnr"
            value={edited.generellInfo.dokumentNr}
            onChange={(e) => dispatch(setEksempelValue("generellInfo.dokumentNr", e.currentTarget.value))}
          />

          <TextInput
            label="Revisionsnr"
            value={edited.generellInfo.revisjonsNr}
            onChange={(e) => dispatch(setEksempelValue("generellInfo.revisjonsNr", e.currentTarget.value))}
          />
        </Group>
      </Stack>
    </Card>
  );
};
